export default "__VITE_ASSET__e9097e01__"